import { UserDefaultIcon } from '@practium/ui';
import type { DashboardUserSummary as DashboardUserSummaryData } from '../../../types/dashboard.types';
import { applyDocumentMask, applyPhoneMask } from '../../../../users/utils/masks';
import styles from './DashboardUserSummary.module.css';

export interface DashboardUserSummaryProps {
	user: DashboardUserSummaryData;
}

export const UserSummary = ({ user }: DashboardUserSummaryProps) => {
	const statusLabel =
		user.status === undefined ? undefined : user.status ? 'Ativo' : 'Inativo';
	const phoneNumber = user.phoneNumber ? applyPhoneMask(user.phoneNumber) : undefined;
	const document = user.document ? applyDocumentMask(user.document) : undefined;

	const details = [
		{ label: 'Perfil', value: user.roleLabel },
		{ label: 'E-mail', value: user.email },
		{ label: 'Telefone', value: phoneNumber },
		{ label: 'Documento', value: document },
		{ label: 'Status', value: statusLabel },
	];

	return (
		<section className={styles.card} aria-label="Resumo do usuario vinculado">
			<div className={styles.identity}>
				<div className={styles.avatarWrapper}>
					{user.avatarUrl ? (
						<img className={styles.avatar} src={user.avatarUrl} alt={user.fullName} />
					) : (
						<UserDefaultIcon className={styles.avatarFallback} />
					)}
				</div>

				<div className={styles.titleGroup}>
					<span className={styles.eyebrow}>Usuario vinculado</span>
					<h2 className={styles.name}>{user.fullName}</h2>
				</div>
			</div>

			{details.length > 0 && (
				<div className={styles.details}>
					{details.map((item) => (
						<div key={item.label} className={styles.detailItem}>
							<span className={styles.detailLabel}>{item.label}</span>
							<span className={styles.detailValue}>{item.value}</span>
						</div>
					))}
				</div>
			)}
		</section>
	);
};
